module.exports = __webpack_public_path__ + "static/media/brs72.27865a9a.png";